export const DOCUMENT_TYPE_BANK_FRONTPAGE = 'bank-frontpage';
